import { render, staticRenderFns } from "./portfolio-repayment.vue?vue&type=template&id=0d4b3e4a&"
import script from "./portfolio-repayment.vue?vue&type=script&lang=js&"
export * from "./portfolio-repayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports